import React from "react";
import usePatchHook from "../../customHooks/usePatchHook";
import APIS from "../../constant/Endpoint";
import { tw } from "@careinfo/tailwind";
import CreateIcon from "../../Icons/CreateIcon";
import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import { useParams } from "react-router-dom";
import Spinner from "../../components/reusable/Spinner";
const EditBrokerComponent = loadable(
  () => import("../../components/Broker/EditBroker")
);

const EditBroker = () => {
  const { id } = useParams();
  const { mutateAsync, isLoading } = usePatchHook({
    queryKey: ["broker"],
    navigateURL: "/",
  });
  const { data, isLoading: isBrokerDataLoding } = useGetHook({
    queryKey: ["broker", `broker-${id}`],
    url: `${APIS.BROKER}${id}/`,
    params: {},
  });
  const handleEdit = async (values: any, setError: any) => {
    const url = APIS.BROKER;
    const formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Broker
        </span>
      </div>
      {isBrokerDataLoding ? (
        <Spinner />
      ) : (
        <EditBrokerComponent
          handleCreate={handleEdit}
          isLoading={isLoading}
          data={data}
        />
      )}
    </>
  );
};
export default EditBroker;
